import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import './styles.css'

function LearningPath({ className = '', photo, slug, title, numTutorials, duration = null }) {
  return (
    <div
      className={`learning-path ${className || ''}`}
      style={{ backgroundImage: `url(${photo.default})` }}
    >
      <Link className="learning-path__wrap" to={`/pathways/${slug}`}>
        <h3 className="learning-path__title">{title}</h3>
        <div className="learning-path__info">
          {numTutorials} Courses
          {duration && <span> · {duration[0]} Hours</span>}
        </div>
      </Link>
    </div>
  )
}

export const LearningPathSummaryPropTypes = {
  duration: PropTypes.arrayOf(PropTypes.number),
  numTutorials: PropTypes.number.isRequired,
  photo: PropTypes.shape({
    default: PropTypes.string.isRequired
  }).isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string
}

LearningPath.propTypes = LearningPathSummaryPropTypes

export default LearningPath
